
<!--
  Footer bar
-->

<template lang="html">
  <div id="footer">  

    <section class="content">  
      <div class="content-inner">
        <p><span class="span-pink">www.ralphandco.com |</span> @ralphcreative</p>

        <p><span class="span-pink">Ralph LONDON |</span> 27-33 Bethnal Green Road, E1 6LA <span class="span-pink">|</span> +44 (0)20 3006 6730 <span class="span-pink">|</span> london@ralphandco.com
        <br/>
        <span class="span-pink">Ralph NEW YORK |</span> 100 Lafayette St, Unit 401, NY, 10013 <span class="span-pink">|</span> +1 (212) 226 2089 <span class="span-pink">|</span> newyork@ralphandco.com
        <br/>
        <span class="span-pink">Ralph LOS ANGELES |</span> 100 Lafayette St, Unit 401, NY, 10013 <span class="span-pink">|</span> +1 (212) 226 2089 <span class="span-pink">|</span> la@ralphandco.com</p>

        <div class="footer-social">

          <div class="footer-logo"><img src="../../static/img/common/ralph_logo.svg" /></div>

          <div class="footer-social-icon"><img src="../../static/img/common/social_linkedin.png" /></div>
          <div class="footer-social-icon"><img src="../../static/img/common/social_twitter.png" /></div>
          <div class="footer-social-icon"><img src="../../static/img/common/social_facebook.png" /></div>
          <div class="footer-social-icon"><img src="../../static/img/common/social_instagram.png" /></div>
          <div class="footer-social-icon"><img src="../../static/img/common/social_vimeo.png" /></div>
        </div>
      </div>
    </section>
    
    <div class="footer-band">
      <div class="footer-band-color ralph-pink"></div>
      <div class="footer-band-color ralph-blue"></div>
      <div class="footer-band-color ralph-orange"></div>
      <div class="footer-band-color ralph-green"></div>
      <div class="footer-band-color ralph-yellow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footbar'
}
</script>

<style>

#footer {
  margin-top:50px;
  text-align: center;
}
#footer p {
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
}
#footer-copyright {

}

.footer-band {
  height:30px;
  background-color: #000
}

.footer-band-color {
  float:left;
  width:20%;
  height:100%;
}

.footer-social {
  text-align: center;
  margin: 60px auto 70px;
  position: relative;
}
.footer-logo {
  width: 120px;
  position: absolute;
  top:-100%;
}
.footer-social-icon {
  width: 38px;
  height:38px;
  display: inline-block;
  margin:0 20px;
  cursor: pointer;
  border-radius: 100%;
  background-color: #fff;
}
.footer-social-icon:hover {
  background-color: #E6007E;
}
.footer-social-icon:active {
  background-color: #E6007E;
}
.footer-social-icon img {
  width: 100%;
}



</style>





// WEBPACK FOOTER //
// Footbar.vue?d608b3d8